/* Ô nhập lịch hẹn dùng chung: phiếu kết quả cuộc gọi (KN-01) và nút "Đặt lịch" */
import React from 'react';
import { DatePicker, Input, Select } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { BRANCHES } from '../dashboard/data';
import { SVC } from '../components/Data';
import { MANGS, type Mang } from './logic';
import type { ApptType } from './appt';

export interface Booking { at: Dayjs | null; branch?: string; mang?: Mang; service?: string; note: string; type?: ApptType }

export const emptyBooking = (mang?: Mang): Booking => ({ at: null, branch: undefined, mang, service: undefined, note: '' });

export const bookingError = (b: Booking) => {
  if (!b.at) return 'Chọn ngày giờ hẹn.';
  if (b.at.isBefore(dayjs())) return 'Giờ hẹn đã qua.';
  if (b.at.hour() < 8 || b.at.hour() >= 21) return 'Cơ sở chỉ nhận lịch từ 08:00 đến 21:00.';
  if (!b.branch) return 'Chọn chi nhánh.';
  if (!b.mang) return 'Chọn mảng.';
  return null;
};

export const Field: React.FC<{ label: string; required?: boolean; children: React.ReactNode; full?: boolean }> = ({ label, required, children, full }) => (
  <label className={`flex min-w-0 flex-col gap-1 ${full ? 'col-span-full' : ''}`}>
    <span className="text-[12px] font-medium text-gray-500 dark:text-gray-400">{label}{required && <span className="text-red-500"> *</span>}</span>
    {children}
  </label>
);

export default function BookingFields({ value, onChange }: { value: Booking; onChange: (b: Booking) => void }) {
  const set = (p: Partial<Booking>) => onChange({ ...value, ...p });
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <Field label="Ngày giờ hẹn" required>
        <DatePicker
          showTime={{ format: 'HH:mm', minuteStep: 15, hideDisabledOptions: true, disabledTime: () => ({ disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7, 21, 22, 23] }) }}
          format="DD/MM/YYYY HH:mm"
          value={value.at}
          onChange={(d) => set({ at: d })}
          disabledDate={(d) => d.isBefore(dayjs(), 'day')}
          placeholder="Chọn ngày giờ"
          className="w-full"
        />
      </Field>
      <Field label="Chi nhánh" required>
        <Select value={value.branch} onChange={(v) => set({ branch: v })} placeholder="Chọn chi nhánh" options={BRANCHES.map((b) => ({ value: b.name, label: b.name }))} />
      </Field>
      <Field label="Mảng" required>
        <Select value={value.mang} onChange={(v) => set({ mang: v, service: undefined })} placeholder="Chọn mảng" options={MANGS.map((m) => ({ value: m, label: m }))} />
      </Field>
      <Field label="Dịch vụ khách quan tâm">
        <Select
          value={value.service}
          onChange={(v) => set({ service: v })}
          placeholder={value.mang ? 'Chọn dịch vụ' : 'Chọn mảng trước'}
          disabled={!value.mang}
          allowClear
          options={(value.mang ? SVC[value.mang] ?? [] : []).map(([n]) => ({ value: n, label: n }))}
        />
      </Field>
      <Field label="Ghi chú cho tư vấn viên" full>
        <Input.TextArea rows={2} value={value.note} onChange={(e) => set({ note: e.target.value })} placeholder="Nhu cầu chính, rào cản, khách cần lưu ý gì khi đến" maxLength={300} />
      </Field>
    </div>
  );
}
